import { HttpEventType } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalAsignarSancionComponent } from "src/app/components/core/layouts/modal-asignar-sancion/modal-asignar-sancion.component";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { SancionService } from "./sancion.service";

@Component({
  selector: "app-sancion",
  templateUrl: "./sancion.component.html",
  styleUrls: ["./sancion.component.scss"],
})
export class SancionComponent implements OnInit {
  formDatos: FormGroup;
  informacionEstablecimiento: any;
  datosRnt: any;
  sancionesActuales: Array<any> = [];
  cod_rnt: number;
  rnt_id: number;

  public isCollapsed = true;

  constructor(
    private sancionService: SancionService,
    private formBuilder: FormBuilder,
    public authService: AuthService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.formulario();
  }

  formulario() {
    this.formDatos = this.formBuilder.group({
      codigo_rnt: [
        "",
        [Validators.required, ConfirmeValidators.numberValidator],
      ],
    });
  }

  getRnt() {
    this.sancionService
      .getConsultaPrestador({ codigo_rnt: this.formDatos.value.codigo_rnt })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.datosRnt = resultado.data ? resultado.data[0] : null;
          this.cod_rnt = this.formDatos.value.codigo_rnt;
          this.rnt_id = this.datosRnt.rnt_id;
          this.getSancionesUsuario(this.rnt_id);
        } else {
          this.datosRnt = null;
          this.cod_rnt = null;
          this.rnt_id = null;
        }
      });
  }

  getSancionesUsuario(rnt_id: number) {
    this.sancionesActuales = [] as Array<any>;
    this.sancionService
      .getSancionesActuales({ rnt_id: rnt_id })
      .subscribe((resultado) => {
        this.sancionesActuales = resultado.data as Array<any>;
      });
  }

  openModalAsignarSancion() {
    const modalRef = this.modalService.open(ModalAsignarSancionComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
    });
    modalRef.componentInstance.asignar = true;
    modalRef.result.then((resultado) => {
      const modalRef1 = this.modalService.open(
        ModalConfirmarRespuestaComponent,
        {
          centered: true,
          backdropClass: "light-blue-backdrop",
          backdrop: "static",
        }
      );
      const confirmarRespuesta = {} as ConfirmarRespuestaModel;
      confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
      confirmarRespuesta.message = `¿Está seguro que desea asignar la sanción?`;
      modalRef1.componentInstance.confirmarRespuesta = confirmarRespuesta;
      modalRef1.result.then((result) => {
        this.sancionService
          .crearSancion({
            titulo: resultado.data.titulo,
            fecha_inicio_sancion: resultado.data.fecha_inicio_sancion,
            fecha_fin_sancion: resultado.data.fecha_fin_sancion,
            motivo: resultado.data.motivo,
            solicitud_id: this.datosRnt.solicitud_id,
            codigo_camara: this.datosRnt.codigo_camara,
            archivo_send: resultado.archivo,
            rnt_id: this.rnt_id,
          })
          .subscribe((result) => {
            if (result) {
              this.getSancionesUsuario(this.rnt_id);
            }
          });
      });
    });
  }

  openModalAnularSancion(item: any) {
    const modalRef = this.modalService.open(ModalAsignarSancionComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
    });
    modalRef.componentInstance.asignar = false;
    modalRef.result.then((resultado) => {
      const modalRef1 = this.modalService.open(
        ModalConfirmarRespuestaComponent,
        {
          centered: true,
          backdropClass: "light-blue-backdrop",
          backdrop: "static",
        }
      );
      const confirmarRespuesta = {} as ConfirmarRespuestaModel;
      confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
      confirmarRespuesta.message = `¿Está seguro que desea anular la sanción?`;
      modalRef1.componentInstance.confirmarRespuesta = confirmarRespuesta;
      modalRef1.result.then((result) => {
        this.sancionService
          .eliminarSancion({
            archivo_send: resultado.archivo,
            motivo: resultado.data.motivo,
            camara_id: this.datosRnt.codigo_camara,
            sancion_id: item.sancion_id,
            solicitud_id: item.solicitud_id,
          })
          .subscribe((result) => {
            this.getSancionesUsuario(this.rnt_id);
          });
      });
    });
  }
}
